export const defined = function(val) {
  return val !== null && val !== undefined
}
